"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadLackUnitMap = exports.resetUnitInfo = exports.updateUserMap = exports.updateUnitMap = void 0;
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const action_constants_1 = require("../../../shared/store/action_constants");
const api_1 = require("../../../../exports/api");
const updateUnitMap = (unitMap) => {
    return {
        type: action_constants_1.UPDATE_UNIT_MAP,
        payload: unitMap,
    };
};
exports.updateUnitMap = updateUnitMap;
const updateUserMap = (userMap) => {
    return {
        type: action_constants_1.UPDATE_USER_MAP,
        payload: userMap,
    };
};
exports.updateUserMap = updateUserMap;
const resetUnitInfo = () => {
    return {
        type: action_constants_1.RESET_UNIT_INFO,
    };
};
exports.resetUnitInfo = resetUnitInfo;
/**
 * load the missing unit information
 * @param names
 * @param linkId
 * @returns
 */
const loadLackUnitMap = (names, linkId) => {
    return (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
        if (!names.length) {
            return;
        }
        const { data: { data: resData } } = yield api_1.Api.searchUnitInfoVo(names, linkId);
        if (!resData.length) {
            return;
        }
        // FIXME: edit type
        return dispatch((0, exports.updateUnitMap)((0, keyBy_1.default)(resData, 'unitId')));
    });
};
exports.loadLackUnitMap = loadLackUnitMap;
//# sourceMappingURL=unit_info.js.map